// Components
import { Entity, EmptyState, Layout } from '@tracklib/kit'
import PlayButton from 'components/playbutton'

// Types
import { ApiRequest, Label } from 'types'

// Utils
import { isBrowser } from '@process'

import styles from './labelslist.css'

type LabelsListProps = {
  labels: Array<Label>
  fetchLabelsRequest: ApiRequest
}
const LabelsList = ({ labels, fetchLabelsRequest }: LabelsListProps): JSX.Element => {
  return (
    <Layout.FullWidth>
      {fetchLabelsRequest.isDone && labels.length === 0 && <EmptyState text="No matching labels found" emoji="looking" />}
      <dl>
        <dd className={styles.grid}>
          {labels.length > 0 &&
            labels.map(({ slug, id, name, cover }) => (
              <Entity
                url={`/label/${slug}`}
                key={id}
                title={name}
                image={cover}
                size={5}
                datatesting="entity_label"
                hoverComponent={<PlayButton entity="label" value={slug} hoverOnly />}
              />
            ))}
          {(fetchLabelsRequest.isLoading || !isBrowser) &&
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(index => (
              <Entity loading key={String(index)} datatesting="entity_loading" />
            ))}
        </dd>
      </dl>
    </Layout.FullWidth>
  )
}

export default LabelsList
